/**
 * Client-side replay types
 *
 * IMPORTANT: This file now re-exports from shared types to ensure
 * client and server use the same type definitions.
 *
 * Previously, client had its own type definitions which could drift
 * from server implementation, causing bugs like:
 * - Sending fields that don't exist in DB (time_elapsed_ms, final_power_ups)
 * - Type mismatches (game_state: string vs number)
 *
 * Now both client and server import from @shared/types, ensuring
 * compile-time and runtime validation consistency.
 */

import { EventTypeSchema } from '../shared-types/replay';

// Re-export shared types
export type {
  TwitterUser,
  ReplaySession,
  ReplayEvent,
  EventData,
  ReplaySessionResponse,
  ReplayListResponse,
  CreateSessionRequest,
  UpdateSessionRequest,
  StateChange,
  GameStateValue
} from '../shared-types/replay';

// Re-export event type enum
export { EventTypeSchema } from '../shared-types/replay';

// Export EventType as a const object for backwards compatibility
export const EventType = {
  BOARD_INIT: 'BOARD_INIT' as const,
  BOARD_STATE: 'BOARD_STATE' as const,
  SWAP: 'SWAP' as const,
  SCORE_UPDATE: 'SCORE_UPDATE' as const,
  POWER_UP: 'POWER_UP' as const,
  GAME_STATE: 'GAME_STATE' as const,
  BARREL_PLACE: 'BARREL_PLACE' as const,
  CLEAR: 'CLEAR' as const,         // NEW
  GRAVITY: 'GRAVITY' as const,     // NEW
  FILL: 'FILL' as const,           // NEW
};

// Re-export GAME_STATE constants
export { GAME_STATE } from '../shared-types/replay';
